import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CookieBanner from './components/ui/CookieBanner';
import Home from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-light-grey" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/features" element={<Features data-id="element-8" />} data-id="element-7" />
            <Route path="/pricing" element={<Pricing data-id="element-10" />} data-id="element-9" />
            <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
            <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
            <Route path="/faq" element={<FAQ data-id="element-16" />} data-id="element-15" />
            <Route path="/privacy" element={<Privacy data-id="element-18" />} data-id="element-17" />
            <Route path="/terms" element={<Terms data-id="element-20" />} data-id="element-19" />
          </Routes>
        </main>
        <Footer data-id="element-21" />
        <CookieBanner data-id="element-22" />
      </div>
    </Router>;
}